import React, { useEffect } from 'react';
import { HeroSection } from '../components/HeroSection';
import { ProblemSection } from '../components/ProblemSection';
import { SolutionSection } from '../components/SolutionSection';
import { BenefitsSection } from '../components/BenefitsSection';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { BonusSection } from '../components/BonusSection';
import { OfferSection } from '../components/OfferSection';
import { Footer } from '../components/Footer';
import { initMetaPixel, trackPageView } from '../utils/metaPixel';
export function LandingPage() {
  useEffect(() => {
    initMetaPixel();
    trackPageView();
  }, []);
  return <div className="min-h-screen bg-white font-sans text-stone-900" data-id="element-399">
      <nav className="bg-white border-b border-stone-100 py-4 sticky top-0 z-50" data-id="element-400">
        <div className="container mx-auto px-4 flex justify-between items-center" data-id="element-401">
          <span className="font-serif font-bold text-xl text-stone-900 tracking-tight" data-id="element-402">
            Mil Hojas <span className="text-amber-600" data-id="element-403">Pro</span>
          </span>
        </div>
      </nav>

      <main data-id="element-404">
        <HeroSection data-id="element-405" />
        <ProblemSection data-id="element-406" />
        <SolutionSection data-id="element-407" />
        <BenefitsSection data-id="element-408" />
        <TestimonialsSection data-id="element-409" />
        <BonusSection data-id="element-410" />
        <OfferSection data-id="element-411" />
      </main>

      <Footer data-id="element-412" />
    </div>;
}